import { c as _c } from "react/compiler-runtime";
import type { ElementType } from 'react';
import { Typography, type TypographyProps } from '@/components/Typography';
import { LocationThumbnail } from '@/components/thumbnails/LocationThumbnail';
import { cn } from '@/lib/cn';
import type { Site } from '@/services/rental-api-client';
export type LocationSelectListProps<T extends ElementType = 'p'> = Omit<TypographyProps<T>, 'variant' | 'noProse'> & {
  site: Site;
};
export function LocationSelectListItem(t0) {
  const $ = _c(17);
  let children;
  let className;
  let props;
  let site;
  if ($[0] !== t0) {
    ({
      site,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = site;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    site = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("flex gap-3 border-1 border-transparent items-center", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = props as TypographyProps<T>;
  let t3;
  if ($[7] !== site) {
    t3 = <div className="avatar"><div className="w-8 rounded-full"><LocationThumbnail width={32} height={32} site={site} /></div></div>;
    $[7] = site;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== site.name) {
    t4 = <LocationSelectListLabel name={site.name} />;
    $[9] = site.name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <Typography variant="paragraph-heavy" className={t1} noProse={true} {...t2}>{t3}{t4}{children}</Typography>;
    $[11] = children;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function LocationSelectListLabel(t0) {
  const $ = _c(8);
  const {
    name
  } = t0;
  let isAirport;
  let t1;
  if ($[0] !== name) {
    const parts = name.trim().split(" ");
    isAirport = parts[parts.length - 1].toLowerCase() === "airport";
    t1 = isAirport ? parts.slice(0, -1).join(" ") : name;
    $[0] = name;
    $[1] = isAirport;
    $[2] = t1;
  } else {
    isAirport = $[1];
    t1 = $[2];
  }
  const nameRes = t1;
  let t2;
  if ($[3] !== isAirport) {
    t2 = isAirport && <span className="text-base-content/60"> Airport</span>;
    $[3] = isAirport;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== nameRes || $[6] !== t2) {
    t3 = <span>{nameRes}{t2}</span>;
    $[5] = nameRes;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}